import React from 'react';
import { PaymentElement } from '@stripe/react-stripe-js';
import styles from '../styles.module.scss';

class CardSection extends React.Component {
  render() {
    return (
      <div className={styles.cardDetailsContainer}>
        <h5 className="font-heavy mb-2">Billing Info</h5>
        <PaymentElement
          options={{
            style: { base: { fontSize: '18px' } },
          }}
        />
      </div>
    );
  }
}

export default CardSection;
